export default "__VITE_ASSET__B7PLDkj3__"